import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const PDFModal = ({ 
  open, 
  onClose, 
  pdfUrl, 
  title = "Reporte PDF",
  showDownloadButton = true,
  showPrintButton = true 
}) => {
  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `reporte_${new Date().toISOString().split('T')[0]}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handlePrint = () => {
    if (pdfUrl) {
      const printWindow = window.open(pdfUrl, '_blank');
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1
      }}>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ 
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: 'action.hover'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
        <Box sx={{ 
          width: '100%', 
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {pdfUrl ? (
            <Box
              component="iframe"
              src={pdfUrl}
              sx={{
                width: '100%',
                height: 'calc(90vh - 120px)',
                border: 'none',
                flex: 1
              }}
              title="PDF Viewer"
            />
          ) : (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              height: '400px',
              flexDirection: 'column',
              gap: 2
            }}>
              <Typography variant="h6" color="text.secondary">
                No hay PDF para mostrar
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        {showDownloadButton && (
          <Button
            variant="contained"
            onClick={handleDownload}
            disabled={!pdfUrl}
            sx={{ minWidth: 120 }}
            style={{color: 'white'}}
          >
            Descargar PDF
          </Button>
        )}
        
        {showPrintButton && (
          <Button
            variant="contained"
            onClick={handlePrint}
            disabled={!pdfUrl}
            sx={{ minWidth: 120 }}
            style={{color: 'white'}}
          >
            Imprimir
          </Button>
        )}
        
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ minWidth: 120 }}
          style={{color: 'white'}}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PDFModal;

